<mat-toolbar>
  <img src="images/logo.svg" alt="Logo" class="w-full" [style.height]="'65px'">
</mat-toolbar>
<div class="menu-scroll">
  <mat-nav-list class="!flex !flex-col !gap-2">
    @for (route of menuRoutes(); track route.path) {
        <a
          mat-list-item
          [routerLink]="route.path"
          [queryParams]="fleetService.routerFleetLinkQueryParams()"
          [routerLinkActive]="['mat-list-item-active']"
        > 
          @if (route.data && route.data['icon']) {
            <mat-icon matListItemIcon>{{ route.data['icon'] }}</mat-icon>
          }
          <span matListItemTitle>{{ getLabel(route) }}</span>
        </a>
    }
  </mat-nav-list>
</div>
